document.addEventListener('DOMContentLoaded', function () {

  // 隐藏描述区域
  const selectors = [
    '.product-description.product-info-block',
    '.content-main.rte',
    '#Product-Tab-Description',
    '#Product-Panel-Description',
    '[id*="Description"]',
    '[aria-controls*="Description"]',
    '.tab-panel.product-tab-panel'
  ];
  
  selectors.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(el) {
      el.style.display = 'none';
    });
  });

  // 缩小 padding
  const bottom = document.querySelector('.product-container-bottom');
  if (bottom) bottom.style.paddingBottom = '0px';
  
  const container = document.querySelector('.product-container.page-width');
  if (container) container.style.paddingBottom = '0px';

});
